export const requiredPoliciesAreAccepted = (
  values: { policiesAndTermsA: boolean, policiesAndTermsB: boolean },
  policyUpToDate: boolean,
) => {
  const policyAccepted = values.policiesAndTermsA && values.policiesAndTermsB;
  return policyUpToDate || policyAccepted;
};
